"use client";

import type { FC, ReactNode } from "react";
import { cn } from "utils";
import {
  ONBOARDING_FLOATING_CTA_BOTTOM_CLASS,
  ONBOARDING_FLOATING_CTA_INSET_NARROW_CLASS,
  ONBOARDING_FLOATING_CTA_INSET_WIDE_CLASS,
  ONBOARDING_FLOATING_CTA_PC_BASE_CLASS,
  ONBOARDING_FLOATING_CTA_PC_NARROW_CLASS,
  ONBOARDING_FLOATING_CTA_PC_WIDE_CLASS,
  ONBOARDING_FLOATING_CTA_SHELL_CLASS,
} from "./onboardingFloatingCtaTokens";

export type OnboardingFloatingCtaInset = "wide" | "narrow";

export interface OnboardingResponsiveCtaFooterProps {
  /** wide = px-6 (viewport −48); narrow = px-4 (viewport −32) */
  inset: OnboardingFloatingCtaInset;
  testId?: string;
  pcClassName?: string;
  className?: string;
  children: ReactNode;
}

export const OnboardingResponsiveCtaFooter: FC<
  OnboardingResponsiveCtaFooterProps
> = ({
  inset,
  testId = "onboarding-responsive-cta-footer",
  pcClassName,
  className,
  children,
}) => (
  <footer
    data-testid={testId}
    data-layout="onboarding-responsive-cta-footer"
    className={cn(
      "relative z-[1]",
      ONBOARDING_FLOATING_CTA_SHELL_CLASS,
      ONBOARDING_FLOATING_CTA_BOTTOM_CLASS,
      inset === "wide"
        ? ONBOARDING_FLOATING_CTA_INSET_WIDE_CLASS
        : ONBOARDING_FLOATING_CTA_INSET_NARROW_CLASS,
      ONBOARDING_FLOATING_CTA_PC_BASE_CLASS,
      inset === "wide"
        ? ONBOARDING_FLOATING_CTA_PC_WIDE_CLASS
        : ONBOARDING_FLOATING_CTA_PC_NARROW_CLASS,
      pcClassName,
      className,
    )}
  >
    {children}
  </footer>
);
